module.exports = __webpack_public_path__ + "img/at.78e4fe8b.svg";